<template>
  <div class="import-modals">
    <confirmation-modal
      :cancel="close"
      :confirm="deleteRow"
      title="Confirme exclusão do Gerente"
      message="Tem certeza que deseja excluir esse Gerente?"
    />
  </div>
</template>

<script>
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import ManagerActions from './ManagerActions';

export default {
  name: 'supervisor-imports',
  mixins: [ManagerActions],
  components: {
    ConfirmationModal,
  },
};
</script>
